import React, {useState, useEffect, useMemo, useCallback, useRef} from "react";
import "./styles.scss";
import axios from 'util/axios';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faToggleOff, faToggleOn} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import update from "immutability-helper";
import Pagination from "../../../util/component/Pagination";

const App = () => {
	const userSelector = useSelector((store) => store.user);
	const [Data, SetData] = useState([]);
	const [Page, SetPage] = useState(1);
	const [Equis, SetEquis] = useState({
		equisYn: "",
	});

	const getData = async () => {
		const postData = {
			curPage: Page,
			boardView: 10,
			miv_start_index: 0,
			miv_end_index: 10,
		}
		const InterfaceStatusList = await axios.post(process.env.REACT_APP_API + "/common/retrieveInterfaceStatusList", postData)
			.then(Response => Response.data.data);
		SetData(InterfaceStatusList);
		const InterfaceStatus = await axios.post(process.env.REACT_APP_API + "/common/retrieveInterfaceStatus", {})
			.then(Response => Response.data.data.result);
		SetEquis((i) => update(i, { $merge: { equisYn: InterfaceStatus[0].status } }));
	}

	const equisClick = async (equisYn) => {
		let response;
		try {
			const postData = {
				status: equisYn ? 0: 1,
				userId: userSelector.userId,
			}
			response = await axios
				.post(
					process.env.REACT_APP_API + ("/common/modifyInterfaceStatus"),
					{...postData}
				)
		} catch (e) {
			console.error(e);
		} finally {
			getData();
		}
	}

	const renderList = (Data) => {
		const render = Data?.result?.map((v, i) => {
			return <tr key={"Data" + i}>
				<td style={{color: "#999"}}>{i + 1}</td>
				<td style={{color: "#999"}}>{v.interface}</td>
				<td style={{color: "#999"}}>{v.status}</td>
				<td style={{color: "#999"}}>{v.userId}</td>
				<td style={{color: "#999"}}>{v.createDt}</td>
			</tr>
		})
		return render;
	}

	const render = useMemo(() => renderList(Data), [Data])
	const movePage = useCallback((i) => { SetPage(i) }, [Page]);

	useEffect(() => {
		getData();
	}, [Page])

	return (
		<div className="bpl-container">
			<section className={"admin_batch"}>
				<div className="top">
					<h3 className="list_name">{("Interface Status")}</h3>
				</div>
				<div className="actions">
					<ul className="work_btn">
						<li style={{
							border: "2px solid",
							color: "#6300ff",
							borderRadius: "10px",
							padding: "5px",
							fontSize: "15px",
							textAlign: "center",
							cursor: "pointer",
							width: "140px"
						}} onClick={() => equisClick(Equis.equisYn)}>
							EQUIS I/F {Equis.equisYn === true ?
							<FontAwesomeIcon icon={faToggleOn} style={{fontSize: "1rem", color: "#6300ff"}}/> :
							<FontAwesomeIcon icon={faToggleOff} style={{fontSize: "1rem", color: "#6300ff"}}/>}
						</li>
					</ul>
				</div>
			</section>
			<section className="admin_batch" style={{display:"none"}}>
				<div className="middle">
				</div>

				<div className="bottom">
					<table>
						<colgroup>
							<col width="30px"></col>
							<col width="100px"></col>
							<col width="100px"></col>
							<col width="100px"></col>
							<col width="100px"></col>
						</colgroup>
						<thead>
						<tr>
							<th>No</th>
							<th>Interface Name</th>
							<th>Status</th>
							<th>User</th>
							<th>Date</th>
						</tr>
						</thead>
						<tbody>
						{render}
						</tbody>
					</table>

					<div className="bottom">
						{Data.boardPager && <Pagination data={Data.boardPager} onClick={movePage}
														style={{
															marginTop: "5px",
															float: "right",
															marginRight: "15px"
														}}/>}
					</div>
				</div>
			</section>
		</div>
	)
}

export default App;
